<!--
 * @Description: 详情弹框组件
 * @Author: 甘佳
 * @Date: 2019-10-11 17:21:19
 -->
<template>
  <div>
    <el-dialog  :visible.sync="viewDialogVisible" :show-close='false' :modal-append-to-body='true' :close-on-click-modal="false" :close-on-press-escape='false' width="800px" class="bullet-detail">
      <div slot="title" class="dialog-title dialog-top">
        <div class="dialog-detail">
          <span  class="detail">{{$lang('订单详情')}}</span>
          <i></i>
          <span class="detail-status">{{statusTitle}}</span>
        </div>
        <img class="dialog-close" src="@/assets/images/close.png" alt=""  @click="closeDetails(false,'close')">
      </div>
      <div  class="dialog-center" v-if="viewDialogVisible">
        <div class="dialog-step1">
          <div class="dialog-step1-ct">
            <div class="dialog-step1-list" >
              <p class="dialog-step1-t1">{{$lang('客户订单号')}}：</p>
              <p class="dialog-step1-t2">{{rowData.customerOrderId}}</p>
            </div>
          </div>
        </div>
        <div class="dialog-step2">
          <div class="dialog-step2-ct">
            <span class="dialog-step2-span">{{$lang('寄方')}}</span>
              <div class="info">
                <div class="contact">
                  <span class="dialog-step2-name ellipsis">{{rowData.senderName}}</span>
                  <span v-if="!isHide" class="dialog-step2-phone">{{'\xa0'}}<span v-mask="{data:{...rowData,apiType:1},  key: 'senderMobilePhone' }" ></span></span>
                  <span v-else class="dialog-step2-phone">{{rowData.senderMobilePhone}}</span>
                </div>
                <div class="dialog-step2-adress">{{rowData.senderProvinceName}}{{rowData.senderCityName}}{{rowData.senderStreet !==undefined && rowData.senderStreet !== null ? rowData.senderStreet:''}}{{rowData.senderDetailedAddress}}</div>
              </div>
          </div>
        </div>
        <div class="dialog-step2" v-if="fromType !== 'editRouter'">
          <div class="dialog-step2-ct">
            <span class="dialog-step2-span get">{{$lang('收方')}}</span>
            <div class="info">
              <div class="contact">
                <span class="dialog-step2-name ellipsis">{{rowData.receiverName}}</span>
                <span v-if="isHide" class="dialog-step2-phone">{{'\xa0' + rowData.receiverMobilePhone}}</span>
                <span v-else class="dialog-step2-phone">{{'\xa0'}}<span v-mask="{data:{...rowData,apiType:2},  key: 'receiverMobilePhone' }" ></span>
                <span v-if="rowData.receiverTelphone" v-mask="{data:{...rowData,apiType:2},  key: 'receiverTelphone' }" >/</span></span>
              </div>
              <div class="dialog-step2-adress">{{rowData.receiverProvinceName}}{{rowData.receiverCityName}}{{rowData.receiverStreet !==undefined && rowData.receiverStreet !== null ? rowData.receiverStreet:''}}{{rowData.receiverDetailedAddress}}</div>
            </div>
          </div>
        </div>
        <div class="attribute-wrap" v-if="fromType !== 'editRouter'">
          <div class="step3-list">
            <p class="step3-list-t1">{{$lang('物品类型')}}：</p>
            <p class="step3-list-t2">{{rowData.goodsTypeName || '--'}}</p>
          </div>
          <div class="step3-list">
            <p class="step3-list-t1">{{$lang('物品名称')}}：</p>
            <p class="step3-list-t2" :title="rowData.goodsName">{{rowData.goodsName || '--'}}</p>
          </div>
          <div class="step3-list">
            <p class="step3-list-t1">{{$lang('物品重量')}}：</p>
            <p class="step3-list-t2">{{rowData.packageTotalWeight || '--'}}</p>
          </div>
          <div class="step3-list expressTypeName" v-show="orderType === 'thridNo'">
            <p class="step3-list-t1">{{$lang('产品类型')}}：</p>
            <p class="step3-list-t2">{{rowData.expressTypeName || '--'}}</p>
          </div>
          <div class="step3-list paymentModeName" v-show="orderType === 'thridNo'">
            <p class="step3-list-t1">{{$lang('结算方式')}}：</p>
            <p class="step3-list-t2">{{rowData.paymentModeName || '--'}}</p>
          </div>
        </div>
      </div>
      <bullet-edit v-if="fromType === 'editRouter'" ref="bulletEdit" :rowData="rowData" @updateformData="val => formParams = val" />
      <div slot="footer" class="dialog-footer"  v-show="bulletTitle==1&&(rowData.orderStatusCode==100||rowData.orderStatusCode==101||rowData.orderStatusCode==102||rowData.orderStatusCode==104)">
        <!-- <el-button type="primary" class="h40" @click="closeDetails(false,'delOrder')" v-show="rowData.orderStatusCode==104">{{$lang('删除订单')}}</el-button> -->
        <el-button v-if="fromType === 'editRouter'" type="primary" :loading="keyBtn" @click="editSave" class="h40">{{ $lang('保 存') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getDetailByWaybillNos } from '@/api/module/customer'
import BulletEdit from './BulletEdit.vue'
export default {
  name: 'Bullet',
  props: ['viewDialogVisible', 'rowData', 'bulletTitle', 'fromType', 'orderType', 'isHide'],
  components: {
    BulletEdit,
  },
  data() {
    return {
      isShowFirst: false,
      statusTitle: '',
      // 物流轨迹
      logistics: [],
      keyBtn: false,
      formParams: {},
    }
  },
  mounted() {

  },
  watch: {
    'rowData': {
      deep: true,
      handler(newVal, oldVal) {
        if (this.bulletTitle === 1) { // 如果是三方下单
        // 订单：(100, "未调派; 101, "已调派网点"; 102, "已调派业务员"; 103, "已取件";  104, "已取消";105, "取件失败")
          switch (Number(this.rowData.orderStatusCode)) {
            case 100:
              this.statusTitle = this.$lang('未下单')
              break
            case 101:
              this.statusTitle = this.$lang('商户取消')
              break
            case 102:
              this.statusTitle = this.$lang('平台取消')
              break
          }
        } else if (this.bulletTitle === 2) { // 如果是三方订单
          // 直接取orderStatusName
          this.statusTitle = this.rowData.orderStatusName
        }
      },
    },
  },

  methods: {
    closeDetails(viewDialogVisible, type) {
      // close:关闭；delWaybill删除运单  ； cancelOrder:取消订单； ediOrder:编辑订单 delOrder:删除订单；
      this.$emit('closeDetails', { 'viewDialogVisible': viewDialogVisible, 'type': type, 'rowData': this.rowData })
    },
    // 获取运单轨迹
    async getDetailByWaybillNo(params) { // 运单状态数据统计
      const { code, data, msg } = await getDetailByWaybillNos(params)
      // 请求成功且有数据
      if (code === 1 && data) {
        this.logistics = data[0].details || []
      } else {
        this.$message.error(msg)
      }
    },
    // 图片展示隐藏变化
    imgDialogChange(val) {
      this.$emit('imgDialogChange', val)
    },
    async editSave () {
      console.log(this.formParams)
      this.$emit('handleSubmit', this.formParams)
    },
  },
}
</script>
<style lang="scss" scoped>
  .yellow{
    color: #E0BD7B !important
  }
  .green{
    color: #52C41A !important
  }
  .activeStatus{
    background: #E0BD7B;
    border: 1px solid #E0BD7B;
  }
  .dialog-top{
    display: flex;
    justify-content:space-between;
    align-items: center;
    .dialog-detail{
      display: flex;
      justify-content:flex-start;
      align-items: center;
      .detail{
        font-size: 24px;
        font-family:PingFangSC-Medium,PingFangSC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:16px;
        font-weight: 600;
      }
      i{
        display: inline-block;
        border-radius: 50%;
        overflow: hidden;
        width: 8px;
        height: 8px;
        background: #fa8b14;
        margin-left: 16px;
        margin-right: 8px;
      }
      .detail-status{
        // width:36px;
        height:12px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFangSC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:12px;
      }
    }
    .dialog-close{
      width: 16px;
      height: 16px;
      display: inline-block;
      cursor: pointer;
    }
  }
  .dialog-center{
    padding: 0 15px;
    .dialog-step1{
      width: 100%;
      display: flex;
      justify-content:flex-start;
      align-items: center;
      padding-bottom: 16px;
      .dialog-step1-ct{
        height: 32px;
        display: flex;
        justify-content:flex-start;
        align-items: center;
        .dialog-step1-list{
          width: 200px;
          height: 36px;
          .dialog-step1-t1{
            width:200px;
            height:14px;
            font-size:14px;
            font-family:PingFangSC-Regular,PingFangSC;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:14px;
            margin: 0;
            margin-bottom: 8px;
          }
          .dialog-step1-t2{
            width:200px;
            height:14px;
            font-size:14px;
            font-family:PingFangSC-Regular,PingFangSC;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:14px;
            margin: 0;
          }
        }
      }
    }
    .dialog-step2{
      padding: 16px 0;
      width: 100%;
      display: flex;
      justify-content:flex-start;
      align-items: center;
      .dialog-step2-ct{
        display: flex;
        justify-content:flex-start;
        align-items: center;
        .dialog-step2-span{
          width: 48px;
          height: 48px;
          background: #e60012;
          display: inline-block;
          border-radius: 50%;
          overflow: hidden;
          font-size:12px;
          font-family:PingFangSC-Regular,PingFangSC;
          font-weight:400;
          color:#fff;
          line-height: 48px;
          text-align: center;
          &.get{
              background: #fff;
              color: #E60012;
              border: 1px solid #e60012;
          }
        }
        .info{
          margin-left: 24px;
          flex: 1;
          .contact{
            margin-bottom: 8px;
          }
        }
        .dialog-step2-name{
          max-width: 180px;
          font-size:16px;
          font-family:PingFangSC-Regular,PingFangSC;
          font-weight:400;
          color:rgba(51,51,51,1);
          font-weight: 600;
        }
        .dialog-step2-phone{
          font-size:14px;
          font-family:PingFangSC-Regular,PingFangSC;
          font-weight:400;
          color:rgba(51,51,51,1);
          margin-left: 24px;
        }
        .dialog-step2-adress{
          height:14px;
          font-size:14px;
          font-family:PingFangSC-Regular,PingFangSC;
          font-weight:400;
          color: #666666;
        }
      }
    }
    .dialog-step3{
      width: 100%;
      height: 36px;
      display: flex;
      justify-content:space-between;
      align-items: center;
      margin-top: 24px;
    }
    .attribute-wrap{
      display: flex;
      justify-content:space-between;
      align-items: center;
      flex-wrap:wrap
    }
    .step3-list{
      width: 200px;
      height: 36px;
      margin-top: 24px;
      .step3-list-t1{
        width:200px;
        height:14px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFangSC;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:14px;
        margin: 0;
      }
      .step3-list-t2{
        width:200px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        height:14px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFangSC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:14px;
        margin: 0;
        margin-top: 8px;
        &.wrap-text {
          overflow: inherit;
          white-space: initial;
        }
      }
      &.expressTypeName{
        width: 265px;
      }
      &.paymentModeName{
        flex: 1;
      }
    }
    .dialog-step4{
      width: 100%;
      height: 142px;
      overflow-y: auto;
      border-bottom: 1px solid #eee;
      border-top: 1px solid #eee;
      margin-top: 16px;
      .step4-list{
        width: 100%;
        height: 14px;
        margin-bottom: 24px;
        color:#999;
        .common-t1{
          display: block;
          height:14px;
          font-size:14px;
          font-family:PingFangSC-Regular,PingFangSC;
          font-weight:400;
          line-height:14px;
          float: left;
        }

        .step4-status{
          width:14px;
          height:14px;
          display: block;
          position: relative;
          margin-left: 16px;
          margin-right: 8px;
          // overflow: hidden;
          float: left;
          .status-name{
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: 14px;
            color: #fff;
            position: absolute;
            font-size: 8px;
            font-family:PingFangSC-Regular,PingFangSC;
            font-weight:400;
          }
          .status-line{
            position: absolute;
            left: 0;
            right: 0;
            top: -20px;
            margin: auto;
            width:1px;
            height:16px;
            background:rgba(221,221,221,1);
            border-radius:1px;
            z-index: 100
          }
        }
      }
      .step4-list:first-of-type{
        margin-top: 16px;
        .status-line{
          display: none
        }
      }
      .step4-list:last-of-type{
        margin-bottom: 16px;
      }
    }
  }
  .c_timeline {
    // margin: 20px 0 20px 20px;
    margin-top: 16px;
    padding-top: 10px;
    transition: all 0.3s linear;

    .c_timeline_item {
        color: #999999;
      display: flex;
      margin-right: 40px;
      &.WARNING{
        color: #E0BD7B;
      }
      &.SIGNED {
        color: #2fb041;
      }
      .item_nr_span {
        margin-right: 12px;
        font-size: 14px;
        margin-right: 16px;
        line-height: 26px;;
      }
      .avue-img--track {
        display: inline-block;
        .el-button--text {
          padding: 0;
        }
      }
      .c_timeline_item_nr {
        position: relative;
        display: flex;
        padding-top: 2px;
        line-height: 20px;
        flex: 1;
        font-size: 12px;
        margin-left: 10px;
        padding-bottom: 20px;
        .c_timeline_item_time {
          line-height: 20px;
          font-size: 12px;
          width: 140px;
          text-align: center;
          margin:0 5px;
        }
        p {
          position: absolute;
          width: 1px;
          height: 16px;
          border-left: #d8d8d8 solid 1px;
          left: -1px;
          top: 13px;
        }
        i {
          position: absolute;
          top: 3px;
          left: -8px;
          font-size: 16px;
          box-sizing: border-box;
        }
        .yuan-icon{
          font-size: 8px;
          margin-left: 2px;
        }
        .iconcaozuopingtaiwentijian {
          color: #f74747;
        }
        .iconcaozuopingtaizhiliujian {
          color: #2fb041;
        }
      }
      .c_timeline_item_nr p:last-child {
        display: none;
      }
    }
  }
</style>
<style lang="scss">
.el-dialog__wrapper.bullet-detail{
  .el-dialog{
    margin-bottom: 0 !important;
    .el-dialog__body{
      max-height: 600px;
      overflow: auto;
    }
  }
  .el-dialog__footer{
    padding: 0;
    margin: 10px 20px 20px;

  }
}
</style>
